import React from 'react';

export type InitiativeTwoSectionProps = {
  className?: string;
};

const InitiativeTwoSection: React.FC<InitiativeTwoSectionProps> = ({
  className = '',
}) => {
  return (
    <div className={`bg-black w-full ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content Section */}
          <div className="space-y-6">
            <div className="space-y-2">
              <p className="text-sm font-semibold text-teal-400 uppercase tracking-wide">Initiative Two</p>
              <h2 className="text-3xl md:text-4xl font-bold text-white">ie-ai Dev Platform</h2>
              <p className="text-lg font-semibold text-gray-50 leading-relaxed py-2">
                The ie-ai Dev Platform is an Enterprise-grade full AI stack, where you all have the opportunity to supercharge your AI skills. 
              </p>
              <p className="text-md text-gray-50 leading-relaxed">
                The flagship AI Lab app is a responsive Claude-style AI platform for using and experimenting with all of the LLM models, private models, Knowledge Storage and Retrieval, Memory, Media Generation and much more.
              </p>
              <p className="text-md text-gray-50 leading-relaxed">
                In the tech stack behind that, products are provisioned for your experimentation which cover the full-lifecycle of Gen-AI Product Development, DevOps, Engineering and QA. 
              </p>
              <p className="text-md text-gray-50 leading-relaxed">
                Your mission, should you accept it, will be to complete a generalist training program with real-world exercises on these tools that will run over the next six months.
              </p>
            </div>
          </div>
          {/* Video Player Section */}
          <div className="w-full">
            <div style={{ position: 'relative', width: '100%', aspectRatio: '16/9', background: '#000', overflow: 'hidden', borderRadius: 12 }}>
              <video
                src="/video/IECompanion.mov"
                controls
                poster="/video/thumbnail.png"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', background: '#000' }}
              >
                Sorry, your browser does not support embedded videos.
              </video>
            </div>
            <p className="text-sm text-gray-300 mt-2 text-left">
              Watch a demonstration of the ie-ai Dev Platform in action
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InitiativeTwoSection; 